import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { ResearchId } from "../../adapters/insights-agent/state/AppState.ts";
import {
  useFiltersState,
  useResearchState,
} from "../../adapters/insights-agent/state/hooks/stateHooks.ts";
import { useFeatureFlagValue } from "../../config/FeatureFlagManager/hooks.ts";
import { ConnectedChatBox } from "./connected-components/ConnectedChatBox.tsx";
import { ConnectedChatMessages } from "./connected-components/ConnectedChatMessages.tsx";
import { ConnectedFilterChips } from "./connected-components/ConnectedFilterChips.tsx";
import { ConnectedFilterDialog } from "../../feature-components/ConnectedFilterDialog/ConnectedFilterDialog.tsx";
import { ConnectedRegenSummary } from "./connected-components/ConnectedRegenSummary.tsx";
import { ConnectedWizard } from "./connected-components/ConnectedWizard.tsx";
import styles from "./WorkflowPage.module.css";

export const InsightsAgentPage = () => {
  const { id } = useParams();
  const filterState = useFiltersState(id as ResearchId);
  const researchState = useResearchState(id as ResearchId);
  const status = researchState?.status;
  const navigate = useNavigate();
  useEffect(() => {
    if (id && id !== "new" && status === "404") {
      navigate("/workflows/new");
    }
  }, [id, navigate, status]);
  const enableFilters = useFeatureFlagValue("enableFilters");
  const enableFilterChips = useFeatureFlagValue("enableFilterChips");
  const enableRegenerateSummary = useFeatureFlagValue(
    "enableRegenerateSummary",
  );
  if (!id) return null;
  return (
    <div className={styles.WorkflowContainer}>
      {id === "new" ? (
        <ConnectedWizard />
      ) : (
        <>
          <ConnectedChatMessages researchId={id as ResearchId} />
          <ConnectedChatBox
            researchId={id as ResearchId}
            filterDialogComponent={
              enableFilters && (
                <ConnectedFilterDialog researchId={id as ResearchId} />
              )
            }
            filterChips={
              enableFilterChips && (
                <ConnectedFilterChips
                  filterState={filterState}
                  researchId={id as ResearchId}
                />
              )
            }
            regenerateButton={
              enableRegenerateSummary && (
                <ConnectedRegenSummary researchId={id as ResearchId} />
              )
            }
          />
        </>
      )}
    </div>
  );
};
